import { useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { WalletAddress } from '@root/entities/wallet'
import { walletsByAddressAtom } from '@root/entities/wallet/atoms'
import { WalletModelShort } from '@root/entities/wallet/ui'
import { WalletAddressTruncated } from '@root/entities/wallet/ui/common/wallet-address-truncated'

import type { TransactionListItemVariant } from './transaction-list-item'
import type { Transaction } from '../../model'

type Props = {
  transferInfo: Transaction.TransferInfo
  variant: TransactionListItemVariant
}

export const TransactionListItemTransferRecipient: React.FC<Props> = ({
  transferInfo,
  variant,
}) => {
  const { t } = useTranslation()

  const [recipientWallet] = useAtom((ctx) => {
    const walletsByAddress = ctx.spy(walletsByAddressAtom)
    return walletsByAddress.get(WalletAddress(transferInfo.to))
  })

  const renderRecipient = () => {
    if (recipientWallet) {
      return <WalletModelShort size="xs" wallet={recipientWallet} />
    }

    return <Address walletAddress={transferInfo.to} />
  }

  return (
    <Root data-variant={variant}>
      {renderRecipient()}
      <Text>{t('transaction.sent-to')}</Text>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 5px;
  justify-items: end;

  &[data-variant='square'] {
    gap: unset;
    justify-items: start;
    margin-inline-start: 30px;
  }
`

const Text = styled(Typography).attrs({
  variant: 'description-semi-bold',
  component: 'span',
})`
  color: var(--text-9);
`

const Address = styled(WalletAddressTruncated)`
  color: var(--appearance-12);
  font-size: 12px;
  font-weight: 600;
`
